const faq = {
	settings: {
		faqItems: document.querySelectorAll('.js-faq')
	},

	init() {
		this.setEvents();
	},

	setEvents() {
		this.settings.faqItems.forEach(item => {
			const button = item.querySelector('.js-btn');
			const toggle = document.getElementById(button.getAttribute('aria-controls'));

			button.addEventListener('click', () => this.toggle(button, toggle));
			button.addEventListener('keydown', e => {
				if (e.key === 'Enter' || e.key === ' ') {
					e.preventDefault();
					this.toggle(button, toggle);
				}
			});
		});
	},

	toggle(activeButton) {
		const isExpanding = activeButton.getAttribute('aria-expanded') !== 'true';

		this.settings.faqItems.forEach(item => {
			const button = item.querySelector('.js-btn');
			const content = document.getElementById(button.getAttribute('aria-controls'));
			const isCurrent = button === activeButton;

			const shouldExpand = isCurrent && isExpanding;

			button.setAttribute('aria-expanded', shouldExpand);
			button.setAttribute('aria-disabled', shouldExpand);
			content.setAttribute('aria-hidden', !shouldExpand);

			if (shouldExpand) {
				this.expand(content);
			} else {
				this.collapse(content);
			}
		});
	},

	expand(el) {
		el.hidden = false;

		if (typeof gsap === 'object' && gsap !== null) {
			gsap.fromTo(el, { height: 0 }, {
				height: el.scrollHeight,
				duration: 0.4,
				onComplete: () => el.style.height = ''
			});
		} else {
			el.style.maxHeight = '0px';
			el.offsetHeight;
			el.style.maxHeight = el.scrollHeight + 'px';

			el.addEventListener('transitionend', () => {
				el.style.maxHeight = '';
			}, { once: true });
		}
	},

	collapse(el) {
		if (typeof gsap === 'object' && gsap !== null) {
			gsap.to(el, {
				height: 0,
				duration: 0.2,
				onComplete: () => {
					el.hidden = true;
					el.style.height = '';
				}
			});
		} else {
			el.style.maxHeight = el.scrollHeight + 'px';
			el.offsetHeight;
			el.style.maxHeight = '0px';

			el.addEventListener('transitionend', () => {
				el.hidden = true;
			}, { once: true });
		}
	}
};

window.addEventListener('DOMContentLoaded', () => faq.init());
